import { render, staticRenderFns } from "./TicketStatus.vue?vue&type=template&id=27ce02e2&scoped=true&lang=pug"
import script from "./TicketStatus.vue?vue&type=script&lang=js"
export * from "./TicketStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ce02e2",
  null
  
)

export default component.exports